/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationconversationplan2Inputs */

const en_moderationconversationplan2 = /** @type {(inputs: Moderationconversationplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan chat`)
};

const de_moderationconversationplan2 = /** @type {(inputs: Moderationconversationplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan-Chat`)
};

/**
* | output |
* | --- |
* | "Plan chat" |
*
* @param {Moderationconversationplan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationconversationplan2 = /** @type {((inputs?: Moderationconversationplan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationconversationplan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationconversationplan2(inputs)
	return de_moderationconversationplan2(inputs)
});
export { moderationconversationplan2 as "moderationConversationPlan" }